module.exports = __webpack_public_path__ + "static/media/dashboard_icon.57d17e4c.png";